import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionModule } from 'primeng/accordion';
import { BadgeModule } from 'primeng/badge';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { GalleriaModule } from 'primeng/galleria';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SidebarModule } from 'primeng/sidebar';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import { AddressNativeRequiredDirective, AddressRequiredDirective, AddressSelectorComponent } from './components/address-selector/address-selector.component';
import { BPMBtnComponent } from './components/bpm-btn/bpm-btn.component';
import { ContentDialogComponent } from './components/content-dialog/content-dialog.component';
import { CurrencyComponent } from './components/currency/currency.component';
import { DataTableComponent } from './components/data-table/data-table.component';
import { ErrorDialogAccordionComponent } from './components/error-dialog-accordion/error-dialog-accordion.component';
import { ErrorDialogComponent } from './components/error-dialog/error-dialog.component';
import { FileCenterComponent } from './components/file-center/file-center.component';
import { FixedBottomPanelComponent } from './components/fixed-bottom-panel/fixed-bottom-panel.component';
import { FixedTopPanelComponent } from './components/fixed-top-panel/fixed-top-panel.component';
import { InputNumberComponent } from './components/input-number/input-number.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { ProcessLogsComponent } from './components/process-logs/process-logs.component';
import { TextCollapseComponent } from './components/text-collapse/text-collapse.component';
import { TodoComponent } from './components/todo/todo.component';
import { CalendarTimeConfirmationDirective } from './directives/calendar-time-confirmation.directive';
import { CalendarValidatorDirective } from './directives/calendar-validator.directive';
import { CheckIdDirective } from './directives/check-id.directive';
import { DetectDifferenceDirective } from './directives/detect-difference.directive';
import { DropdownSettingDirective } from './directives/dropdown-setting.directive';
import { NumberInputMinValidatorDirective } from './directives/number-input-min-validator.directive';
import { PrimeCalendarInputFormatValidateDirective } from './directives/prime-calendar-input-format-validate.directive';
import { PrimeCalendarInputMaskDirective } from './directives/prime-calendar-input-mask.directive';
import { CounterMaximumPipe } from './pipes/counter-maximum.pipe';
import { CurrencyExchangePipe } from './pipes/currency-exchange.pipe';
import { CurrencyFormatterPipe } from './pipes/currency-formatter.pipe';
import { CustomOptionsMappingPipe } from './pipes/custom-options-mapping.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { ImageUrlPipe } from './pipes/image-url.pipe';
import { InputNumberFractionDigitByCurrencyPipe } from './pipes/input-number-fraction-digit-by-currency.pipe';
import { OptionsMappingPipe } from './pipes/options-mapping.pipe';
import { ReplaceNullWithPipe } from './pipes/replace-null-with.pipe';
import { TaxPipe } from './pipes/tax.pipe';
import { ImageUrlCachePipe } from './pipes/image-url-cache.pipe';
import { ValidateIdNumberDirective } from './directives/validate-id-number.directive';

const primeNgModule = [
  AccordionModule,
  ButtonModule,
  BlockUIModule,
  DialogModule,
  GalleriaModule,
  InputTextModule,
  InputTextareaModule,
  MultiSelectModule,
  TableModule,
  TooltipModule,
  SidebarModule,
  SplitButtonModule,
  PanelMenuModule,
  ProgressSpinnerModule,
  InputNumberModule,
  TabViewModule,
  BadgeModule,
  DropdownModule
];

@NgModule({
  declarations: [
    ContentDialogComponent,
    DataTableComponent,
    ErrorDialogComponent,
    ErrorDialogAccordionComponent,
    FileCenterComponent,
    AddressSelectorComponent,
    FixedBottomPanelComponent,
    FixedTopPanelComponent,
    PageHeaderComponent,
    ProcessLogsComponent,
    DetectDifferenceDirective,
    PrimeCalendarInputMaskDirective,
    CounterMaximumPipe,
    OptionsMappingPipe,
    ReplaceNullWithPipe,
    BPMBtnComponent,
    TextCollapseComponent,
    TodoComponent,
    PrimeCalendarInputFormatValidateDirective,
    CalendarValidatorDirective,
    CheckIdDirective,
    CurrencyComponent,
    CustomOptionsMappingPipe,
    CalendarTimeConfirmationDirective,
    InputNumberFractionDigitByCurrencyPipe,
    FileSizePipe,
    NumberInputMinValidatorDirective,
    InputNumberComponent,
    CurrencyFormatterPipe,
    ImageUrlPipe,
    AddressRequiredDirective,
    AddressNativeRequiredDirective,
    TaxPipe,
    CurrencyExchangePipe,
    ImageUrlCachePipe,
    ValidateIdNumberDirective,
    DropdownSettingDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ...primeNgModule,
  ],
  exports: [
    ContentDialogComponent,
    DataTableComponent,
    ErrorDialogComponent,
    ErrorDialogAccordionComponent,
    FileCenterComponent,
    AddressSelectorComponent,
    FixedBottomPanelComponent,
    FixedTopPanelComponent,
    PageHeaderComponent,
    ProcessLogsComponent,
    DetectDifferenceDirective,
    PrimeCalendarInputMaskDirective,
    CounterMaximumPipe,
    OptionsMappingPipe,
    ReplaceNullWithPipe,
    BPMBtnComponent,
    TextCollapseComponent,
    TodoComponent,
    PrimeCalendarInputFormatValidateDirective,
    CalendarValidatorDirective,
    CheckIdDirective,
    CurrencyComponent,
    CustomOptionsMappingPipe,
    InputNumberFractionDigitByCurrencyPipe,
    NumberInputMinValidatorDirective,
    InputNumberComponent,
    CurrencyFormatterPipe,
    ImageUrlPipe,
    AddressRequiredDirective,
    AddressNativeRequiredDirective,
    TaxPipe,
    CurrencyExchangePipe,
    ValidateIdNumberDirective,
    DropdownSettingDirective
  ],
})
export class SharedModule { }
